
import Vue from "vue";
import NavSideBar from "@/components/candidate/NavSideBar.vue";
import GuidedTooltip from "@/components/shared/GuidedTooltip.vue";
import { 
  TOOLTIP_VISIBLE,
  TOOLTIP_CURRENT_ID,
  TOOLTIP_CURRENT_STEP
} from "@/store/modules/tooltip/constants";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "RecruiterWrapper",
  components: { 
    NavSideBar,
    GuidedTooltip 
  },
  computed: {
    ...mapGetters("tooltip", {
      tooltipsVisible: TOOLTIP_VISIBLE,
      currentTooltipId: TOOLTIP_CURRENT_ID,
      currentStep: TOOLTIP_CURRENT_STEP,
      currentTooltipConfig: "currentTooltipConfig"
    }),
    ...mapGetters("auth", {
      user: "GET_USER_DETAILS"
    })
  },
  watch: {
    '$route'(newRoute, oldRoute) {
      // Check if route changed and trigger appropriate tooltips
      if (newRoute.path !== oldRoute?.path) {
        setTimeout(() => {
          this.$store.dispatch('tooltip/checkRouteTooltips', { 
            userRole: 'recruiter', 
            routePath: newRoute.path 
          });
        }, 500);
      }
    }
  },
  methods: {
    ...mapActions("tooltip", {
      setTooltipVisibility: "setTooltipVisibility",
      nextTooltipStep: "nextTooltipStep",
      previousTooltipStep: "previousTooltipStep",
      completeTooltip: "completeTooltip",
      skipTooltip: "skipTooltip"
    }),
    
    onStepChanged(step: number) {
      // Step change is handled by the component internally
    },
    
    onTooltipSkipped() {
      this.skipTooltip();
    },
    
    onTooltipFinished() {
      this.completeTooltip();
    },
    
    onTooltipClosed() {
      this.skipTooltip();
    }
  }
});
